var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: { id: "glossary-results", "aria-live": "polite", role: "region" }
    },
    _vm._l(_vm.terms, function(term, termIndex) {
      return _c(
        "div",
        {
          key: term.GLOSSARY_ENTRY_ID,
          staticClass: "term",
          attrs: { id: "term-" + term.GLOSSARY_ENTRY_ID }
        },
        [
          _vm.hasPermission(term.STUDENT_RID) &&
          _vm.editing === term.GLOSSARY_ENTRY_ID
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "form-group col-xs-12 col-md-6" }, [
                  _c("label", {
                    staticClass: "sr-onl",
                    attrs: { for: "name-" + term.GLOSSARY_ENTRY_ID }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: term.TERM,
                        expression: "term.TERM"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "name-" + term.GLOSSARY_ENTRY_ID,
                      type: "text"
                    },
                    domProps: { value: term.TERM },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(term, "TERM", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            : _c(
                "h2",
                {
                  staticClass: "term-title",
                  staticStyle: { "padding-top": "20px" },
                  attrs: { id: term.TERM }
                },
                [
                  _c(
                    "span",
                    { class: { "text-danger": term.APPROVED_FLG === "N" } },
                    [_vm._v(_vm._s(term.TERM))]
                  ),
                  _vm._v(" "),
                  term.APPROVED_FLG === "N"
                    ? _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top-center",
                              value: {
                                content: _vm.$t(
                                  "MAIN_CONTENT.GlossaryResults.awaitingTeacherApproval"
                                ),
                                trigger: "hover click"
                              },
                              expression:
                                "{content: $t('MAIN_CONTENT.GlossaryResults.awaitingTeacherApproval'), trigger: 'hover click'}",
                              modifiers: { "top-center": true }
                            }
                          ],
                          staticClass: "btn-unstyled",
                          attrs: {
                            "data-toggle": "popover",
                            "data-html": "true"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-exclamation-circle text-danger",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermission(term.STUDENT_RID)
                    ? _c(
                        "button",
                        {
                          staticClass: "btn-unstyled text-muted",
                          attrs: {
                            role: "button",
                            "aria-label": "Edit-" + term.GLOSSARY_ENTRY_ID
                          },
                          on: {
                            click: function($event) {
                              return _vm.onEdit(term.GLOSSARY_ENTRY_ID, "name")
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fas fa-pencil-alt",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    : _vm._e()
                ]
              ),
          _vm._v(" "),
          _c("div", { staticClass: "author text-sm text-muted" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("MAIN_CONTENT.GlossaryResults.authorWithColon")) +
                " \n\t\t\t"
            ),
            _c("strong", { staticClass: "name" }, [
              _vm._v("\n\t\t\t\t" + _vm._s(term.DISPLAY_NAME) + "\n\t\t\t")
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v("\n\t\t\t\t" + _vm._s(term.CREATED_DATE) + "\n\t\t\t")
            ])
          ]),
          _vm._v(" "),
          _vm.hasPermission(term.STUDENT_RID) &&
          _vm.editing === term.GLOSSARY_ENTRY_ID
            ? _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("ckeditor4", {
                    attrs: { editor: _vm.editor, config: _vm.editorConfig },
                    on: { ready: _vm.onEditorReady },
                    model: {
                      value: term.DEFINITION,
                      callback: function($$v) {
                        _vm.$set(term, "DEFINITION", $$v)
                      },
                      expression: "term.DEFINITION"
                    }
                  })
                ],
                1
              )
            : _c("div", {
                staticClass: "definition",
                class: { editable: _vm.hasPermission(term.STUDENT_RID) },
                attrs: { id: "def-" + term.GLOSSARY_ENTRY_ID },
                domProps: { innerHTML: _vm._s(term.DEFINITION) },
                on: {
                  click: function($event) {
                    return _vm.onEdit(term.GLOSSARY_ENTRY_ID, "definition")
                  }
                }
              }),
          _vm._v(" "),
          term.FILES && term.FILES.length
            ? _c("div", { staticClass: "class-items" }, [
                _c("div", { staticClass: "flex-container box" }, [
                  _c(
                    "div",
                    {
                      staticClass: "category-icon",
                      class: _vm.getColorClass("O")
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "icon",
                          staticStyle: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              _vm.isFolderOpen = !_vm.isFolderOpen
                            }
                          }
                        },
                        [
                          _vm.isFolderOpen
                            ? _c("font-awesome-icon", {
                                attrs: { icon: "folder-open" }
                              })
                            : _c("font-awesome-icon", {
                                attrs: { icon: "folder" }
                              })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "content-details",
                      staticStyle: {
                        "background-color": "#FFFFFF",
                        border: "1px solid #EDEDED"
                      }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              return _vm.toggleFolder()
                            }
                          }
                        },
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.GlossaryResults.attachedFilesTitleCase"
                                )
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("p"),
                      _vm._v(" "),
                      _vm.isFolderOpen
                        ? _c(
                            "div",
                            { staticClass: "folder-items" },
                            _vm._l(term.FILES, function(file, fileIndex) {
                              return _c(
                                "div",
                                { key: "file_" + fileIndex },
                                [
                                  file.CONTENT_TYPE === "msword"
                                    ? _c("font-awesome-icon", {
                                        attrs: { icon: "file-word" }
                                      })
                                    : file.CONTENT_TYPE === "pdf"
                                    ? _c("font-awesome-icon", {
                                        attrs: { icon: ["far", "file-pdf"] }
                                      })
                                    : file.CONTENT_TYPE ===
                                      "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    ? _c("font-awesome-icon", {
                                        attrs: { icon: ["far", "file-excel"] }
                                      })
                                    : file.CONTENT_TYPE ===
                                      "vnd.openxmlformats-officedocument.presentationml.presentation"
                                    ? _c("font-awesome-icon", {
                                        attrs: {
                                          icon: ["far", "file-powerpoint"]
                                        }
                                      })
                                    : _c("font-awesome-icon", {
                                        attrs: { icon: "file" }
                                      }),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: file.ATTACHMENT_URL,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(file.CONTENT_FILENAME) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.editing === term.GLOSSARY_ENTRY_ID
                                    ? _c("font-awesome-icon", {
                                        staticClass: "pull-right",
                                        attrs: { icon: "trash" },
                                        on: {
                                          click: function($event) {
                                            return term.FILES.splice(
                                              fileIndex,
                                              1
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasPermission(term.STUDENT_RID) &&
          _vm.editing !== term.GLOSSARY_ENTRY_ID
            ? _c(
                "button",
                {
                  staticClass: "btn btn-default",
                  attrs: { role: "button", "aria-label": "Edit " + term.TERM },
                  on: {
                    click: function($event) {
                      return _vm.onEdit(term.GLOSSARY_ENTRY_ID, "definition")
                    }
                  }
                },
                [
                  _c("font-awesome-icon", { attrs: { icon: "pencil-alt" } }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("MAIN_CONTENT.GlossaryResults.edit")) +
                      "\n\t\t"
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasPermission(term.STUDENT_RID) &&
          _vm.editing !== term.GLOSSARY_ENTRY_ID
            ? _c(
                "button",
                {
                  staticClass: "btn btn-default",
                  attrs: { role: "button", "aria-label": "Delete " + term },
                  on: {
                    click: function($event) {
                      return _vm.deleteTerm(term)
                    }
                  }
                },
                [
                  _c("font-awesome-icon", { attrs: { icon: "trash" } }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("MAIN_CONTENT.GlossaryResults.delete")) +
                      "\n\t\t"
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasPermission(term.STUDENT_RID) &&
          _vm.editing === term.GLOSSARY_ENTRY_ID
            ? _c(
                "div",
                [
                  _c("file-uploader", {
                    ref: "fileUpload",
                    refInFor: true,
                    attrs: {
                      nameHeader: _vm.$t("MAIN_CONTENT.commonContent.name"),
                      sizeHeader: _vm.$t("MAIN_CONTENT.commonContent.size"),
                      removeHeader: _vm.$t("MAIN_CONTENT.commonContent.remove"),
                      dropSingleFile: _vm.$t(
                        "MAIN_CONTENT.commonContent.dropSingleFile"
                      ),
                      dropMultipleFiles: _vm.$t(
                        "MAIN_CONTENT.commonContent.dropMultipleFiles"
                      ),
                      selectSingleFile: _vm.$t(
                        "MAIN_CONTENT.commonContent.selectSingleFile"
                      ),
                      selectMultipleFiles: _vm.$t(
                        "MAIN_CONTENT.commonContent.selectMultipleFiles"
                      ),
                      attachFile: _vm.$t(
                        "MAIN_CONTENT.commonContent.attachFile"
                      ),
                      attachFiles: _vm.$t(
                        "MAIN_CONTENT.commonContent.attachFiles"
                      ),
                      files: term.NEW_FILES,
                      termData: term,
                      postAction:
                        "/PortalAPI/index.cfm/api/v1/class-pages/" +
                        _vm.$route.params.courseSectionGUID +
                        "/files?student_rid=" +
                        _vm.selectedStudent.STUDENT_RID,
                      auth: {
                        Authorization: "bearer " + _vm.accessToken,
                        "Client-ID": _vm.$store.state.clientID
                      },
                      URL: _vm.externalFileData
                    },
                    on: {
                      saveGoogleFilesData: _vm.saveGoogleFileData,
                      saveDropboxFilesData: _vm.saveDropboxFileData,
                      saveOneDriveFilesData: _vm.saveOneDriveFileData,
                      updateFiles: function($event) {
                        return _vm.updateValue(term, termIndex)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          term.ENTRY_NOTES !== "" && _vm.editing !== term.GLOSSARY_ENTRY_ID
            ? _c("div", { staticClass: "teacher-note-wrap" }, [
                _c("p", [
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.$t("MAIN_CONTENT.GlossaryResults.teacherNote"))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", {
                  domProps: { innerHTML: _vm._s(term.ENTRY_NOTES) }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasPermission(term.STUDENT_RID) &&
          _vm.editing === term.GLOSSARY_ENTRY_ID
            ? _c("div", { staticClass: "form-group text-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-default",
                    on: { click: _vm.onCancel }
                  },
                  [_vm._v(_vm._s(_vm.$t("commonText.cancel")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    on: {
                      click: function($event) {
                        return _vm.save(term)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("commonText.save")))]
                )
              ])
            : _vm._e()
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }